<template>
  <div id="map"></div>
</template>
<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import * as olProj from 'ol/proj'
import { lonLatSearchPlace } from '@/api/manage'
import ScaleLine from 'ol/control/ScaleLine'
import { defaults } from 'ol/interaction'
import Feature from 'ol/Feature'
import { unByKey } from 'ol/Observable'
import { Vector as VectorLayer } from 'ol/layer'
import { gcj02tobd09, wgs84togcj02, gcj02towgs84 } from '../../../sys/components/zuobiaozhuanhuan'
import { getVectorContext } from 'ol/render'
import LineString from 'ol/geom/LineString'
import * as turf from '@turf/turf'
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from 'ol/style'
let lastTime
var geoMarker
var routeFeature
var styles
const distance = 0
var position
var data
export default {
  data () {
    return {
      map: null,
      data: [0, 0],
      pointdata: { point: '', address: '' }
    }
  },
  created () { },
  mounted () {
    this.initMap()
  },
  methods: {
    // resetCenter(data){
    //   this.endMarker
    // }
    changepoint (data) {
      this.data = data || [0, 0]
      this.createIcon()
    },
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      this.map = new Map({
        view: new View({
          center: [113.67939908770235, 25.53576677844281], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 14, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: 'map' // 地图容器id
      })
      const scaleLineControl = new ScaleLine({
        // 设置度量单位为米
        units: 'metric',
        target: 'scalebar',
        className: 'ol-scale-line'
      })
      this.map.addControl(scaleLineControl)
      const roadLayer = new TileLayer({
        name: '底图',
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      this.map.addLayer(roadLayer)
      this.createIcon()
    },
    createIcon () {
      if (this.vectorLayer) {
        this.vectorLayer.getSource().clear()
        this.map.removeLayer(this.vectorLayer)
      }
      this.endMarker = new Feature({
        type: 'endicon',
        geometry: new Point(this.data)
      })
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [this.endMarker]
        }),
        style: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: require('@/assets/myImg/1/icon_mypositon_map@2x.png')
          })
        })
      })
      this.map.addLayer(this.vectorLayer)
      var that = this
      if (this.mapKey) {
        unByKey(this.mapKey)
      }
      this.mapKey = this.map.on('click', event => {
        console.log('click=====lonlatMap')
        that.data = event.coordinate
        that.findPosition(event.coordinate[0], event.coordinate[1])
        that.endMarker.getGeometry().setCoordinates(that.data)
      })
    },
    findPosition (x, y) {
      const wgs84togcj02Data = wgs84togcj02(x, y)
      lonLatSearchPlace(wgs84togcj02Data[0], wgs84togcj02Data[1])
        .then(({ data }) => {
          this.pointdata.address = data.regeocode.formatted_address
          // this.pointdata.point = data.regeocode.roadinters[0].location
          this.pointdata.point = String(x) + ',' + String(y)
          this.$emit('handleMapOk', this.pointdata)
          // console.log(this.pointdata.address)
          console.log(this.pointdata.point)
        })
        .catch(() => { })
    }
  }
}
</script>

<style lang="less" scoped>
#map {
  width: 750px;
  height: 300px;
}
</style>
